import React from 'react';

import List from './user/List'

function User(){
	return(
	
			<List/>
			

	);
}

export default User;